module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10200.363f49fe.jpg";